import { createSlice } from "@reduxjs/toolkit"

const UserSlice = createSlice({
  name: "User",
  initialState: {
    allUserDetailsList: "",
  },

  editUsers: {
    isEdit: false,
    data: null,
  },

  singleUserData: null,
  reducers: {
    //for created by
    setAllUserDetailsList: (state, action) => ({
      ...state,
      allUserDetailsList: action.payload,
    }),
    setEditUsers: (state, action) => ({
      ...state,
      editUsers: action.payload,
    }),
    setSingleUserData: (state, action) => ({
      ...state,
      singleUserData: action.payload,
    }),
  },
})

export const { setAllUserDetailsList,setEditUsers,setSingleUserData} = UserSlice.actions

export default UserSlice.reducer
